import React, { Fragment } from 'react';

const Plan = (props) => {
    const {
        plan: {
            issuerName,
            planName
        },

    } = props;

    return (
        <Fragment>
            <div className="" style={{ 'marginBottom': '0' }}>
                {issuerName}
            </div>
            <span style={{ 'display': 'block', 'marginTop': 0, 'marginBottom': 0 }}
                className="text-base">
                {planName}
            </span>
        </Fragment>
    );
};

export default Plan;